import { render } from "./PortalSidebarNav.vue?vue&type=template&id=3c80125e"
import script from "./PortalSidebarNav.vue?vue&type=script&lang=js"
export * from "./PortalSidebarNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__